import { writable } from "svelte/store";
import type { AvailableCredit, Credit, CreditRedemption } from "@shared/types/Credit";

export type CreditResource = "index" | "available" | "redemptions";

export interface CreditsStore {
  credits: Credit[];
  redemptions: CreditRedemption[];
  available: AvailableCredit[];
  loaded: { [k in CreditResource]: boolean };
  failed: boolean;
  pagination: {
    page: number;
    perPage: number;
    totalEntries: number;
  };
}

const paginationInitialState = {
  page: 1,
  perPage: 15,
  totalEntries: 0,
};

const defaultCreditsStore = {
  credits: [],
  redemptions: [],
  available: [],
  loaded: {
    available: false,
    index: false,
    redemptions: false
  },
  failed: false,
  pagination: paginationInitialState,
};

export const creditsStore = writable<CreditsStore>(defaultCreditsStore);
